/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent } from 'react';
import { IUserImgWIthDelete } from './types';
import { CircularAvatar } from '../../../../../../CustomAvatar';
import { useSelectWithParams } from '../../../../../../../../../utils/selector.utils';
import { userSelectors } from '../../../../../../../../../app/resource/user/user.selectors';

export const UserImgWithDelete: FunctionComponent<IUserImgWIthDelete> = ({ onDelete, userId }) => {
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);

  return (
    user && (
      <div className="user-image-with-delete-container">
        <a className="small-avatar mr-05">
          <CircularAvatar
            src={user.image}
            title={`${user.firstName} ${user.lastName}`}
            size="30"
            classes="img-fluid"
            styles={{ verticalAlign: 'baseline' }}
          />
        </a>
        <div className="close-btn" onClick={onDelete}>
          ×
        </div>
      </div>
    )
  );
};
